import { render, staticRenderFns } from "./numberCodeLogin.vue?vue&type=template&id=c72ea166&scoped=true"
import script from "./numberCodeLogin.vue?vue&type=script&lang=js"
export * from "./numberCodeLogin.vue?vue&type=script&lang=js"
import style0 from "./numberCodeLogin.vue?vue&type=style&index=0&id=c72ea166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72ea166",
  null
  
)

export default component.exports